<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <card
              title="Total Employees"
              :value="totalKaryawan"
              iconClass="ni ni-single-02"
              iconBackground="bg-gradient-primary"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              title="This Month's Salary"
              :value="convertRp(totalGajiBulanIni)"
              iconClass="fa fa-usd"
              iconBackground="bg-gradient-danger"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              title="Last Month's Salary"
              :value="convertRp(totalGajiBulanLalu)"
              iconClass="ni ni-paper-diploma"
              iconBackground="bg-gradient-success"
              directionReverse
            ></card>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <card
              title="Total Users"
              :value="totalUsers"
              iconClass="ni ni-satisfied"
              iconBackground="bg-gradient-warning"
              directionReverse
            ></card>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-7 mb-lg">
            <!-- line chart -->
            <div class="card z-index-2">
              <gradient-line-chart />
            </div>
          </div>
          <div class="col-lg-5">
            <carousel />
          </div>
        </div>

        <!-- DASHBOARD TELAT DAN PULANG CEPAT -->
        <!-- <div class="row mt-4">
          <div class="col-6 mb-lg-0 mb-4">
            <div class="card">
              <div class="card-header" style="background-color: #F08080;">
                <div class="row">
                  <div class="col-3">
                    <div class=" pb-0">
                      <h6 class="text-white">Employees are late</h6>
                    </div>
                  </div>
                  <div class="col-4">
                    
                  </div>
                  <div class="col-5 float-right">
                    <argon-button
                      variant="gradient"
                      color="secondary"
                      size="sm"
                      @click="filterTelat()"
                    ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                    <a class="btn btn-sm btn-warning" style="margin-top: 12px; margin-left: 20px;" :href="apiUrl+'print-pdf/employee-telat?start_date='+searchTelat.start_date+'&end_date='+searchTelat.end_date+'&nama='+searchTelat.nama+'&jabatan='+searchTelat.jabatan+'&unit='+searchTelat.unit+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a>
                  </div>
                </div>
              </div>
              <div class="table-responsive scroll">
                <table class="table align-items-center table-striped">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Nama</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Unit</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">JABATAN</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">DATE</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">SHIFT</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">FINGER TIME</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">LATE</th>
                      <th class="text-secondary"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in tableTelat.data" :key="i">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">{{ row.id_karyawan }}</p>
                            <h6 class="mb-0 text-sm">{{ row.nama }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                          <span class="text-secondary text-xs font-weight-bold">{{ row.unit }}</span>
                      </td>
                      <td>
                          <span class="text-secondary text-xs font-weight-bold">{{ row.jabatan }}</span>
                      </td>
                      <td class="text-sm align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ moment(row.date).locale('id').format('LL') }}</span>
                      </td>
                      <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.shift }}</span>
                      </td>
                      <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.time }}</span>
                      </td>
                      <td class="text-sm align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.telat }} Menit</span>
                      </td>
                      <td class="text-secondary"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
              </div>
            </div>
          </div>

          <div class="col-6 mb-lg-0 mb-4">
            <div class="card">
              <div class="card-header" style="background-color: #7B68EE;">
                <div class="row">
                  <div class="col-4">
                    <div class=" pb-0">
                      <h6 class="text-white">Employees go home early</h6>
                    </div>
                  </div>
                  <div class="col-3">
                  </div>
                  <div class="col-5 float-right">
                    <argon-button
                      variant="gradient"
                      color="secondary"
                      size="sm"
                      @click="filterTelat()"
                    ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                    <a class="btn btn-sm btn-warning" style="margin-top: 12px; margin-left: 20px;" :href="apiUrl+'print-pdf/employee-pulang-cepat?start_date='+searchTelat.start_date+'&end_date='+searchTelat.end_date+'&nama='+searchTelat.nama+'&jabatan='+searchTelat.jabatan+'&unit='+searchTelat.unit+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a>
                  </div>
                </div>
              </div>
              <div class="table-responsive scroll">
                <table class="table align-items-center table-striped">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Nama</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Unit</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">JABATAN</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">DATE</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">SHIFT</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">FINGER TIME</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">LATE</th>
                      <th class="text-secondary"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in tablePulangCepat.data" :key="i">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">{{ row.id_karyawan }}</p>
                            <h6 class="mb-0 text-sm">{{ row.nama }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                          <span class="text-secondary text-xs font-weight-bold">{{ row.unit }}</span>
                      </td>
                      <td>
                          <span class="text-secondary text-xs font-weight-bold">{{ row.jabatan }}</span>
                      </td>
                      <td class="text-sm align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ moment(row.date).locale('id').format('LL') }}</span>
                      </td>
                      <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.shift }}</span>
                      </td>
                      <td class="align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.time }}</span>
                      </td>
                      <td class="text-sm align-middle text-center">
                          <span class="text-secondary text-xs font-weight-bold">{{ row.telat }} Menit</span>
                      </td>
                      <td class="text-secondary"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
              </div>
            </div>
          </div>
        </div> -->

        <!-- Employee Hour Performance -->
        <div class="row mt-4">
          <div class="col-lg-12 mb-lg-0 mb-4">
            <div class="card">
              <div class="row mb-4">
                <div class="col-4">
                  <div class="card-header pb-0">
                    <h6>Man Hour</h6>
                  </div>
                </div>
                <div class="col-4">
                </div>
                <div class="col-4 float-right">
                  <argon-button
                    style="margin-right: 10px; margin-left: 60px;"
                    class="mt-4"
                    variant="gradient"
                    color="secondary"
                    size="sm"
                    @click="filter()"
                  ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                  <a class="btn btn-sm btn-warning" style="margin-top: 40px;" :href="apiUrl+'print-pdf/ehp?periode_start='+search.periode_start+'&periode_end='+search.periode_end+'&nama='+search.nama+'&jabatan='+search.jabatan+'&unit='+search.unit+''" target="_BLANK"><i class="fa fa-print fa-sm"></i> Print</a>
                </div>
              </div>
              <div class="table-responsive scroll">
                <table class="table align-items-center table-striped">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">No</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Name</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder  ps-2">Department</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">Posision</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">normal working hours</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">overtime working hours</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder ">total working hours</th>
                      <th class="text-secondary"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i">
                      <td>
                        <div class="text-center">
                          <h6 class="mb-0 text-sm">{{ i + 1 }} .</h6>
                        </div>
                      </td>
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <!-- <div>
                            <img src="" />
                          </div> -->
                          <div class="ms-4">
                            <h6 class="mb-0 text-sm">{{ row.name }}</h6>
                            <p class="mb-0 text-xs font-weight-bold">{{ row.nik }}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-left">
                          <h6 class="mb-0 text-sm">{{ row.department }}</h6>
                        </div>
                      </td>
                      <td>
                        <div class="text-left">
                          <h6 class="mb-0 text-sm">{{ row.position }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm"> {{ (8 * row.total_kerja_count) }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm">{{ row.total_ot_count }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <h6 class="mb-0 text-sm">{{ (+(8 * row.total_kerja_count) + +(row.total_ot_count)) }}</h6>
                        </div>
                      </td>
                      <td class="text-secondary"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
            </div>
            </div>
          </div>
        </div>

        <!-- =======  MODAL FILTER TELAT ======= -->
        <div class="container">
          <vue-final-modal v-model="formFilterTelat.show" classes="modal-container" content-class="modal-content" :z-index="10000">
            <!-- header -->
            <div class="row">
              <div class="col-11 float-left">
                <span class="modal__title">{{formFilterTelat.title}}</span>
              </div>
              <div class="col-1 float-right">
                <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilterTelat.show = false"></i>
              </div>
            </div><hr>
            <!-- end header -->
            <div class="modal__content container">
              <label for="example-text-input" class="form-control-label mt-3">Start Date</label>
              <input type="date" class="form-control" placeholder="Start Date" v-model="searchTelat.start_date">
              <label for="example-text-input" class="form-control-label mt-3">End Date</label>
              <input type="date" class="form-control" placeholder="End Date" v-model="searchTelat.end_date">
              <label for="example-text-input" class="form-control-label mt-3">Nama</label>
              <input type="text" class="form-control" placeholder="Nama" v-model="searchTelat.nama">
              <label for="example-text-input" class="form-control-label mt-3">Jabatan</label>
              <input type="text" class="form-control" placeholder="Jabatan" v-model="searchTelat.jabatan">
              <label for="example-text-input" class="form-control-label mt-3">Unit</label>
              <input type="text" class="form-control" placeholder="Unit" v-model="searchTelat.unit">
            </div>
            <!-- footer -->
            <div class="row float-right mt-3">
              <div class="col-6"> 
              </div>
              <div class="col-2" style="margin-right: 20px;">
                <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilterTelat.show = true">Close</argon-button>
              </div>
              <div class="col-1">
                <argon-button variant="gradient" color="success" size="sm" width="1" @click="getTelat()">Filter</argon-button>
              </div>
            </div>
            <!-- end footer -->
          </vue-final-modal>
        </div>

        <!-- =======  MODAL FILTER ======= -->
        <div class="container">
          <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
            <!-- header -->
            <div class="row">
              <div class="col-11 float-left">
                <span class="modal__title">{{formFilter.title}}</span>
              </div>
              <div class="col-1 float-right">
                <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
              </div>
            </div><hr>
            <!-- end header -->
            <div class="modal__content container">
              <label for="example-text-input" class="form-control-label mt-3">Periode Start</label>
              <input type="date" class="form-control" placeholder="Periode Start" v-model="search.periode_start">
              <label for="example-text-input" class="form-control-label mt-3">Periode End</label>
              <input type="date" class="form-control" placeholder="Periode End" v-model="search.periode_end">
              <label for="example-text-input" class="form-control-label mt-3">Nama</label>
              <input type="text" class="form-control" placeholder="Nama" v-model="search.nama" required>
              <label for="example-text-input" class="form-control-label mt-3">Jabatan</label>
              <input type="text" class="form-control" placeholder="Jabatan" v-model="search.jabatan" required>
              <label for="example-text-input" class="form-control-label mt-3">Unit</label>
              <input type="text" class="form-control" placeholder="Unit" v-model="search.unit" required>
            </div>
            <!-- footer -->
            <div class="row float-right mt-3">
              <div class="col-6"> 
              </div>
              <div class="col-2" style="margin-right: 20px;">
                <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilter.show = true">Close</argon-button>
              </div>
              <div class="col-1">
                <argon-button variant="gradient" color="success" size="sm" width="1" @click="getEhp()">Filter</argon-button>
              </div>
            </div>
            <!-- end footer -->
          </vue-final-modal>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
import { VueFinalModal } from 'vue-final-modal'
import ArgonButton from "@/components/ArgonButton.vue";
import Api from '@/helpers/api';
var moment = require('moment');
import config from '@/configs/config';
import dashboard from '@/services/human_resource/dashboard.service';
// import akun from '@/services/akun.service';

export default {
  name: "dashboard-default",
  data() {
    return {
      moment:moment,
      table: {
        data: []
      },
      tableTelat: {
        data: []
      },
      tablePulangCepat: {
        data: []
      },
      totalKaryawan: '',
      totalGajiBulanIni: '',
      totalGajiBulanLalu: '',
      totalUsers: '',
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      formFilterTelat: {
        add: true,
        title: "Filter",
        show: false
      },
      search: {
        periode_start: '',
        periode_end: '',
        nama: '',
        jabatan: '',
        unit: '',
      },
      searchTelat: {
        start_date: '',
        end_date: '',
        nama: '',
        jabatan: '',
        unit: '',
      },
      apiUrl :config.apiUrl,
      role: '',
    };
  },
  components: {
    Card,
    ArgonButton,
    VueFinalModal,
  },
  mounted(){
    // this.get();
    this.getEhp();
    // this.getTelat();
    // this.getRole();
  },
  methods: {
    get(param){
      let context = this;               
      Api(context, dashboard.index()).onSuccess(function(response) {    
          context.table.data         = response.data.data.EHP;
          context.totalKaryawan      = response.data.data.totalKaryawan;
          context.totalGajiBulanIni  = response.data.data.totalGajiBulanIni;
          context.totalGajiBulanLalu = response.data.data.totalGajiBulanLalu;
          context.totalUsers         = response.data.data.totalUsers;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
      }).onFinish(function() { 
         // context.formFilter.show  = false;
      })
      .call()
    },
    getEhp(param){
      let context = this;               
      Api(context, dashboard.showEhp({ periode_start: context.search.periode_start, periode_end: context.search.periode_end, nama: context.search.nama, jabatan: context.search.jabatan, unit: context.search.unit})).onSuccess(function(response) {    
          context.table.data = response.data.data.EHP;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
      }).onFinish(function() { 
         context.formFilter.show  = false;
      })
      .call()
    },
    getTelat(param){
      let context = this;               
      Api(context, dashboard.logTelat({nama: context.searchTelat.nama, jabatan: context.searchTelat.jabatan, unit: context.searchTelat.unit, start_date: context.searchTelat.start_date, end_date: context.searchTelat.end_date})).onSuccess(function(response) {    
          context.tableTelat.data       = response.data.data.dataTelat;
          context.tablePulangCepat.data = response.data.data.dataPulangCepat;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableTelat.data = [];
          }
      }).onFinish(function() { 
         context.formFilterTelat.show  = false;
      })
      .call()
    },
    // getRole(){
    //   let context = this;     
    //   context.onLoading = true;
    //   Api(context, akun.indexProfile()).onSuccess(function(response) {
    //       context.role = response.data.data[0].role;
    //       if (response.data.data[0].role != 'Admin') {
    //         context.$router.push({ path: /detail-profile/+response.data.data[0].employee_id})
    //       }
    //   }).onError(function(error) {  
    //   })
    //   .call() 
    // },
    convertRp(bilangan) {
      if (bilangan) {
        var number_string = bilangan.toString(),
            sisa    = number_string.length % 3,
            rupiah  = number_string.substr(0, sisa),
            ribuan  = number_string.substr(sisa).match(/\d{3}/g);

        if(ribuan){
          var separator = sisa ? '.' : '';
          rupiah += separator + ribuan.join('.');
          return rupiah
        }else{
          return bilangan
        }
      }
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading = false;
    },
    filterTelat() {
      this.formFilterTelat.add   = true;
      this.formFilterTelat.show  = true;
      this.formFilterTelat.title = "Filter";
      this.onLoading = false;
    },
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 500px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #F0F8FF;
}
</style>
